module.exports = __webpack_public_path__ + "img/CV.Utilities.Potable_water.Cast_iron_pipe.7722a1ab.png";